import { Wifi, WifiOff } from "lucide-react";

// Online / offline icon shown at the left of a customer's name (green = app open now, grey = offline, dim = never signed in).
export const Presence = ({ id, online, lastSeen, installed = true }) => {
  const title = online ? "Online now" : lastSeen ? `Offline · last seen ${new Date(lastSeen).toLocaleString()}` : installed ? "Offline · never signed in" : "Not signed in yet";
  return (
    <span data-testid={`presence-${id}`} data-online={online ? "1" : "0"} title={title}
      className={`flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full border ${online ? "border-[#3ecf8e]/50 bg-[#3ecf8e]/15 text-[#3ecf8e] shadow-[0_0_8px_rgba(62,207,142,.45)]" : "border-white/10 bg-white/5 text-[#5b6577]"}`}>
      {online ? <Wifi className="h-3 w-3" /> : <WifiOff className="h-3 w-3" />}
    </span>
  );
};
